




















































































import {Component, Vue, Watch} from "vue-property-decorator"
import store from "./../store"
import {adminApiService} from "./../services/admin-api"
import {debounce} from "./../services/debounce"
import {systemSrv} from "./../services/system"
import router from "@/router"
import eventBus from "./../eventBus"

@Component({
  components: {},
})
export default class AddTenant extends Vue {
  loading = false
  multipleFilter = false
  types = ["Full Time", "Part Time", "Flex Time"]
  tags = ["All", "Approved", "Pending Approval", "Rejected", "Draft", "Archived"]
  data: any = {
    options: {},
    showStatusFilter: true,
    statusFilters: [],
    fab: false,
    mall: null,
    sunwayMalls: [],
    singleSelect: false,
    search: "",
    selected: [],
    headers: [
      {
        text: "Name",
        sortable: true,
        value: "name",
      },
      {
        text: "Email",
        sortable: true,
        value: "email",
      },
      {
        text: "Phone",
        sortable: true,
        value: "phone",
      },
      {
        text: "Categories of Interest",
        sortable: true,
        value: "categories",
      },
      {
        text: "Availability",
        value: "availabilityDateFrom",
        sortable: true,
      },
      
      {
        text: "Types",
        sortable: true,
        value: "types",
      },
      {
        text: "Blacklisted",
        sortable: true,
        value: "blacklisted",
        align: "center",
      },
    ],
    items: [],
    categoryFilter: "",
    typeFilter: "",
    pageMeta: {
      limit: 10,
      offset: 0,
      total: 0,
    },
  }

  categories: any = []

  created() {
    this.data.sunwayMalls = [...this.$store.getters.sunwayMalls]
    this.loadCategoriesForFilter()
  }

  async loadCategoriesForFilter() {
    this.categories = await adminApiService.loadCategories({q: this.data.categoryFilter})
    this.data.categories = this.categories
  }

  @Watch("data.options")
  onPropertyChanged(value: string, oldValue: string) {
    console.log("data.options watch detected", value, oldValue)
    this.data.pageMeta.offset = (this.data.options.page - 1) * this.data.pageMeta.limit
    this.data.pageMeta.sort = this.data.options.sortBy[0] ? this.data.options.sortBy[0] : "createdAt"
    this.data.pageMeta.order = "asc"
    if (this.data.options.sortDesc[0] && this.data.options.sortDesc[0] == true) {
      this.data.pageMeta.order = "desc"
    }
    this.init()
  }
  @Watch("data.search")
  async doSearch(value: string, oldValue: string) {
    var myEfficientFn = debounce.delay(() => {
      this.data.pageMeta.offset = 0
      this.data.pageMeta.q = value
      this.data.pageMeta.categories = this.data.categoryFilter
      this.data.pageMeta.types = this.data.typeFilter
      this.init()
    }, 450)
  }
  changedMall(mall) {
    this.data.mall = mall
  }
  @Watch("data.categoryFilter")
  updateCategoryFilter(value: string) {
    var myEfficientFn = debounce.delay(() => {
      this.data.pageMeta.offset = 0
      this.data.pageMeta.q = this.data.search
      this.data.pageMeta.categories = this.data.categoryFilter
      this.data.pageMeta.types = this.data.typeFilter
      this.init()
    }, 450)
  }
  @Watch("data.typeFilter")
  updateTypeFilter(value: string) {
    var myEfficientFn = debounce.delay(() => {
      this.data.pageMeta.offset = 0
      this.data.pageMeta.q = this.data.search
      this.data.pageMeta.categories = this.data.categoryFilter
      this.data.pageMeta.types = this.data.typeFilter
      this.init()
    }, 450)
  }
  selectRow(item) {
    console.log("view", item)
    this.$router.push({name: "jobSeekersView", params: {id: item._id}})
  }
  add() {
    this.$router.push({name: "jobSeekersView", params: {id: "0"}})
  }
  updateStatusFilter(val) {
    if (this.multipleFilter == true) {
      let existing = this.data.statusFilters.find((i) => {
        return i == val
      })
      if (existing) {
        this.data.statusFilters = this.data.statusFilters.filter((i) => {
          return i != val
        })
      } else {
        this.data.statusFilters.push(val)
      }
    } else {
      this.data.statusFilters = val == "All" ? [] : [val]
    }
    this.init()
  }
  async init() {
    let payload = Object.assign({}, this.data.mall)
    if (this.data.statusFilters.length > 0) {
      payload.status = this.data.statusFilters.join(",")
    }
    this.loading = true
    let result = await adminApiService.jobSeekers(payload, this.data.pageMeta)
    this.loading = false
    if (result && result.error == true) {
      this.data.errors.text = result.message
      this.data.errors.show = true
      return
    }
    if (result && result.docs) {
      this.data.items = result.docs
      this.data.pageMeta.total = result.total
    }
  }
  getColor(status) {
    if (status == "Rejected") return "orange"
    else if (status == "Pending Approval") return "red"
    else if (status == "Archived") return "blue-grey"
    else if (status == "Draft") return "grey"
    else return "green"
  }
}
